import { useContext } from "react";
import "./stories.scss"
import { AuthContext } from "../../context/authContext"

const Stories = () => {

  const {currentUser} = useContext(AuthContext)

  //TEMPORARY
  const stories = [
    {
      id: 1,
      name: "Target Alpha",
      img: "/images/target_profile_cropped.png",
    },
    {
      id: 2,
      name: "Target Beta",
      img: "/images/target_profile_cropped_alt1.png",
    },
    {
      id: 3,
      name: "Target Gamma",
      img: "/images/target_profile_cropped_alt2.png",
    },
    {
      id: 4,
      name: "Target Delta",
      img: "/images/target_profile_cropped_alt3.png",
    },
  ];

  return (
    <div className="stories">
      <div className="story">
          <img src="/images/new_target.png" alt="" />
          <span>New target</span>
          <button>+</button>
        </div>
      {stories.map(story=>(
        <div className="story" key={story.id}>
          <img src={story.img} alt="" />
          <span>{story.name}</span>
        </div>
      ))}
    </div>
  )
}

export default Stories